<div class="details-container">
  <div
    class="details-header"
    style="background: url(assets/images/readinggirls1.jpg)"
  >
    <div class="details-banner">
      <h1>Reading Girls’ School</h1>
      <h2>11 Plus (11+) Exam Information</h2>
    </div>
  </div>

  <div class="details-publisher">
    <span><strong>Published by - SEHYOG Academy</strong></span>
  </div>

  <div class="details-content">
    <div class="details-section">
      <h3>Introduction</h3>

      <div class="spacer"></div>

      <p>
        Established in 1818, Reading Girls’ School is a partially selective,
        bilateral school for girls in Reading, Berkshire. Approximately 430
        girls are educated by 25 staff members. The school is known for its
        focus on business and enterprise. Students are encouraged to strive for
        excellence academically and socially and the curriculum offers a broad
        range of subjects and extra-curricular activities. Although not a
        grammar, Reading Girls’ does use an 11 Plus-style entrance test as part
        of its admissions process <br />
        <br />
      </p>

      <div class="spacer"></div>

      <div class="spacer"></div>

      <h2>11 Plus Exam Information for Reading Girls’ School</h2>

      <p>
        <strong>Address: </strong> Reading Girls School, Northumberland Avenue,
        Reading, RG2 7PY
      </p>
      <p><strong>County: </strong>Reading</p>
      <p>
        <strong>Admissions info:</strong> admin&#64;readinggirlsschool.net, 0118 986
        1336
      </p>
      <p><strong>School type: </strong> Co-educational, partially selective</p>
      <p><strong>Number of pupils: </strong> 430 (approx.)</p>
      <p>
        <strong>Number of places in Year 7:</strong> 170 (42 by selective
        stream)
      </p>
      <p><strong>Open Day date: </strong> March</p>
      <p><strong>Exam date:</strong> October</p>
      <p><strong>Exam type / Board: </strong> CEM</p>

      <div class="spacer"></div>
      <div class="spacer"></div>

      <h2>Reading Girls’ School 11 Plus Admissions</h2>

      <div class="spacer"></div>

      <p>
        This article is relevant for those aiming for entry to the school based
        on the Selective Stream Test, of which there are 42 allocated places.
        The school also offers entry via the Coordinated Secondary Admissions
        Scheme. <br />
        <br />

        Admission to Reading Girls’ School in Year 7 follows the process set out
        by Coordinated Secondary Admissions Scheme, which is responsible for
        setting the school’s admissions policy. Each year, the school admits
        approximately 170 places, 42 of which are selected based on ability.
        <br />
        <br />

        Students who have Special Educational Needs or an Education, Health and
        Care Plan are given priority of place above other students. <br />
        <br />

        In cases where there are more applicants than available places, the
        school uses the following oversubscription criteria, giving priority to:
      </p>

      <p>
        1. Looked After and previously Looked After girls. <br />
        2. Students who score highest in the selection test. <br />
        3. Girls who have medical or social grounds for attending the school.
        <br />
        4. Girls who have a sister who currently attends the school. <br />
        5. Students who live closest to the school.
      </p>

      <div class="spacer"></div>

      <h2>
        How to Apply for 11 Plus (11+) Selective Entry to Reading Girls’ School
      </h2>

      <div class="spacer"></div>

      <p>
        Before applying for a place at Reading Girls’ School, parents and
        students are encouraged to attend the school’s Open Day, which usually
        takes place in March. At the event, parents and students will have the
        opportunity to tour the school and meet current staff and students.
        <br />
        <br />

        Once parents have visited the school and are sure that Reading Girls’ is
        the right establishment for their daughter, applications should be made
        to the appropriate Local Authority (LA), or submitted online. <br />
        <br />

        Students who wish to apply for one of the 42 selective places, should
        also complete the school’s registration form, which can be accessed
        here.
      </p>

      <h2>Reading Girls’ School Selective Stream Test (11 Plus Exam) Format</h2>

      <p>
        Of the 170 available places at the school, 42 are allocated to students
        who score the highest in the Selective Stream Test. The exam takes place
        in October and is administered by the exam board, CEM. The test is taken
        online and covers the following topics: <br />
        <br />

        1. Verbal reasoning <br />
        2. Non-verbal reasoning <br />
        3. Mathematics <br />
        <br />

        Your daughter must be pre-registered to take this test. <br />
        <br />

        For more information on the Selective Stream Test, please visit the
        Selective Stream Test page on the school’s website.
      </p>

      <h2>How to Prepare for the Reading Girls’ School 11 Plus Exam?</h2>

      <p>
        A little forward planning can go a long way to helping students perform
        well in the Reading Girls’ School Selective Stream Test. As a starting
        point, we’d suggest that parents read our 11 Plus guide for parents for
        an overview of what the test typically involves. <br />
        <br />

        Once a study schedule is in place, using practice exam papers in
        addition to regular preparation can really help boost a student’s
        performance. Our practice papers help students become familiar with the
        layout of the exam and the types of questions that may be asked on test
        day. They can also help identify any weak areas that may need
        improvement prior to the exam.
      </p>
    </div>
  </div>
</div>
